export enum WebTour {
  START_PAGE = 'startPage',
  PROJECT_DETAILS = 'projectDetails',
}
